import $ from 'jquery';
import toastr from 'toastr';

export default function bind() {
  const notifications = $('#notifications')
    .html()
    .trim();
  if (notifications) {
    success(notifications);
  }

  const errorNotifications = $('#errorNotifications')
    .html()
    .trim();
  if (errorNotifications) {
    error(errorNotifications);
  }
}

export function success(content) {
  toastr.success(content);
}

export function error(content) {
  toastr.error(content);
}



// WEBPACK FOOTER //
// ./src/plugins/toastr.js